if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      // Call showActiveMedia after the modal is shown
      this.showActiveMedia();
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute("data-media-id");
      
      // Find the slide with matching data-media-id
      const activeSlide = this.querySelector(`[data-media-id="${mediaId}"]`);
      
      if (!activeSlide) {
        console.warn(`Media with ID ${mediaId} not found in modal`);
        return;
      }
      
      // Remove active class from all slides
      this.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('active');
      });
      
      // Add active class to the clicked slide
      activeSlide.classList.add('active');
      
      // Get the carousel component and navigate to this slide
      const carouselComponent = this.querySelector('carousel-component');
      if (carouselComponent && carouselComponent.carousel) {
        // Find the index of the slide
        const slides = Array.from(this.querySelectorAll('.splide__slide[data-media-id]'));
        const slideIndex = slides.findIndex(slide => slide.getAttribute('data-media-id') === mediaId);
        
        if (slideIndex !== -1) {
          // Use a small timeout to ensure carousel is ready
          setTimeout(() => {
            try {
              carouselComponent.carousel.go(slideIndex);
            } catch (e) {
              console.warn('Failed to navigate carousel:', e);
              activeSlide.scrollIntoView();
            }
          }, 0);
        }
      } else {
        // Fallback: scroll into view if carousel is not available
        activeSlide.scrollIntoView();
      }
      
      // Handle deferred media (videos)
      const activeMediaTemplate = activeSlide.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      
      if (activeSlide.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) {
        activeSlide.loadContent();
      }
    }
  });
}